import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [프로비저닝 > 기본정보] 프로비저닝 설정 관련 basicinfo_set 정보를 조회한다.
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getProvisioningBasicinfo(params) {
    return axios.post(`${baseUrl}/settings/provisioning-setting/get-provisioning-basicinfo.do`, params);
  },
  /**
   * [프로비저닝 > 요청 프로세스] 승인 프로세스 관련 정보를 조회한다.
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getVmsReqTaskList(params) {
    return axios.post(`${baseUrl}/settings/provisioning-setting/get-vms-req-task-list.do`, params);
  },
  /**
   * [프로비저닝 > 요청 프로세스] 접수자, 1차 승인자, 2차 승인자, 확인자에 대한 활성화 여부를 수정한다.
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateVmsReqTaskList(params) {
    return axios.post(`${baseUrl}/settings/provisioning-setting/update-vms-req-task-list.do`, params);
  },
  /**
   * [프로비저닝 > 요청 프로세스] 등록된 접수자, 1차 승인자, 2차 승인자, 확인자 목록을 수정한다.
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateVmsReqTaskMgrList(params) {
    return axios.post(`${baseUrl}/settings/provisioning-setting/update-vms-req-task-mgr-list.do`, params);
  },
  /**
   * [프로비저닝 > IP범위 설정 > IP관리 범위 추가] IP주소와 subnetbit로 IP 대역을 계산한다.
   * @author jeee12
   * @param  {[type]} params ipaddress, subnetbit
   * @return {[type]}        [description]
   */
  getDHCPList(params) {
    return axios.post(`${baseUrl}/settings/provisioning-setting/get-dhcp-list.do`, params);
  },
  /**
   * [프로비저닝 > IP범위 설정] 가상화 센터와 하위 호스트들에 대한 트리 데이터 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getVirtualcenterHostTreeData(params) {
    return axios.post(`${baseUrl}/settings/provisioning-setting/get-virtualcenter-host-tree-data.do`, params);
  },
  /**
   * [프로비저닝 > IP범위 설정] 선택한 호스트에 대한 IP관리범위 목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getHostIpRangeList(params) {
    return axios.post(`${baseUrl}/settings/provisioning-setting/get-host-ip-range-list.do`, params);
  },
  /**
   * [프로비저닝 > IP범위 설정] 가상화센터 그룹에 속한 호스트 정보 목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getVirtualcenterHostIpList(params) {
    return axios.post(`${baseUrl}/settings/provisioning-setting/get-virtualcenter-host-ip-list.do`, params);
  },
  /**
   * [프로비저닝 > IP범위 설정] 호스트에 해당한 IP관리 범위 추가
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertVmsHostIpRange(params) {
    return axios.post(`${baseUrl}/settings/provisioning-setting/insert-vms-host-ip-range.do`, params);
  },
  /**
   * [프로비저닝 > IP범위 설정] 선택한 호스트 IP관리 범위 목록 삭제
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteVmsHostIpRangeList(params) {
    return axios.post(`${baseUrl}/settings/provisioning-setting/delete-vms-host-ip-range-list.do`, params);
  },
  /**
   * [프로비저닝 > IP범위 설정] 선택한 호스트 IP관리 범위에 따른 IP 사용 현황 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getCurrentIpTableList(params) {
    return axios.post(`${baseUrl}/settings/provisioning-setting/get-current-ip-table-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/virtual/provisioning-settings.js